// extracted by mini-css-extract-plugin
module.exports = {"show-xs":"index_show-xs_1E-s_","hide-xs":"index_hide-xs_3jtlu","block":"index_block_3jnFT","inner":"index_inner_1wpPF","form":"index_form_1dixL"};